import fetchBook from "../../services/LibraryBook";

export default {
	namespaced: true,
	state: {
		loaded: false,
		book: {},
		read_more: {},
		navigation: {},
		error: false
	},
	mutations: {
		startFetch(state) {
			state.error = false;
			state.loaded = false;
			state.navigation = {};
			state.book = {},
			state.read_more = {}
		},
		saveBook(state, book) {
			state.loaded = true;
			state.error = false;
			state.book = book;
		},
		saveActiveChapter(state, activeChapter) {
			state.activeChapter = activeChapter;
		},
		saveNavigation(state, navigation) {
			state.navigation = navigation;
		},
		throwError(state) {
			state.error = true;
			state.loaded = false;
			state.book = {};
			state.navigation = {};
			state.book = {};
		}
	},
	actions: {
		async fetchBook(store, playload) {
			try {
				store.commit("startFetch");

				let book = await fetchBook(playload.bookId);
				
				if (book.chapters.length === 0){
					throw ': список глав пуст'
				}
				if (!playload.chapterId || playload.chapterId == 0) {
					throw ': значение главы не является номером'
				}
				if (playload.chapterId < 1 || playload.chapterId > book.chapters.length) {
					throw ': неверный номер главы'
				} 
				
				let activeChapterId = playload.chapterId - 1;

				store.commit("saveBook", book);

				store.dispatch('updateNavigation', {
					activeChapterId: activeChapterId
				});

			} catch (e) {
				store.commit("throwError");
				store.dispatch(
					"PageHeading/showError",
					{
						style: "danger",
						message: "Не удается загрузить книгу"+e,
						time: 3
					},
					{ root: true }
				);
			}
		},
		updateNavigation(store, playload){
			let bookLength = store.state.book.chapters.length - 1;
			let activeId = playload.activeChapterId;

			let navigation = {
				active: activeId, //0
				next: activeId >= bookLength ? false : activeId + 1,
				prev: activeId <= 0 ? false : activeId - 1,
			};
			
			store.commit("saveNavigation", navigation);
		}
	}
};



// WEBPACK FOOTER //
// ./src/store/modules/LibraryBook/index.js